import {
    CreditCardProductCategory,
    ScoredCreditCardProductsCategory,
} from '@appTypes/EligibilityApi.interface'

import { getSanitisedCardName } from './getSanitisedCardName'

interface GetCardByCategoryOptions {
    cardId: string
    category: CreditCardProductCategory
    subProductCode?: string
}

export function getCardByCategory(
    scoredCategories: ScoredCreditCardProductsCategory[],
    options: GetCardByCategoryOptions
) {
    if (!Array.isArray(scoredCategories)) {
        return null
    }

    const activeCategory = scoredCategories.find(
        category => category.id === options.category
    )

    const matchingCards = activeCategory?.creditCards.filter(
        product =>
            getSanitisedCardName(product.name) ===
            getSanitisedCardName(options.cardId)
    )

    if (matchingCards == null || matchingCards.length <= 1) {
        return matchingCards?.[0]
    }

    return (
        matchingCards.find(
            product => product.subProductCode === options.subProductCode
        ) ?? matchingCards[0]
    )
}
